import { createSlice } from '@reduxjs/toolkit';

export interface IRedirectMapping {
  redirectUrl: string | null;
  analyticsParam: string | null;
}

export interface IRedirectState {
  redirectMappings: Record<string, IRedirectMapping>;
}

const initialState: IRedirectState = {
  redirectMappings: {},
};

const redirectSlice = createSlice({
  name: 'redirect',
  initialState,
  reducers: {},
});

export const { reducer: redirectReducer } = redirectSlice;
